var radioButton = function () {
    // Check status on page load
    $("[data-id='form-selectable-label'] input:checked").each(
        function () {
            $(this).parent().addClass('selected');
        }
    );


    // Add/remove checkbox selected class
    $('[data-id="form-selectable-label"]').find('input[type=checkbox]').on("change", function () {
        if ($(this).is(':checked')) {

            $(this).parent().addClass('selected');
        }
        else {
            $(this).parent().removeClass('selected');
        }
    });

    // Add/remove radio selected class
    $('[data-id="form-selectable-label"]').find('input[type=radio]').on('focus', function () {


        $(this).parents('[data-id="form-selectable-group"]').find('input[type=radio]').each(
        function () {
            $(this).parent().removeClass('selected');
        }
        );



        $(this).parent().addClass("selected");
    })


}